import { isEnvDevelopment } from 'ENV_CONFIG';
import { useDispatch } from 'react-redux';
import { setExperiences } from '../actions';
import { DEV_EXPERIENCES } from '../constants';
import {
  getExperience,
  getCampaigns,
  isParamTrue,
  getUniqueCampaigns,
  getDecodedExperiences,
} from '../helpers';

const HEAD = 'HEAD';

const useExperiences = () => {
  const dispatch = useDispatch();

  // getMonetateExperiences() method will dispatch the experience data to store it in redux
  const getMonetateExperiences = () => {
    if (isEnvDevelopment) {
      dispatch(setExperiences(DEV_EXPERIENCES));
      return;
    }

    const requestBody = {
      method: HEAD,
    };

    const url = new URL(document.location);
    fetch(url.href, { ...requestBody })
      .then((res) => {
        const decodedExperiences = getDecodedExperiences(res);
        dispatch(setExperiences(decodedExperiences));
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error('Failed parsing x-experiences-json', error);
      });
  };

  // To set the campaigns data in window.jlData
  // Which is Adobe to collect data from Monetate analytics
  // Call handleMonetateCampaigns(@experiences)
  // @experiences --> List of all the experiences
  const handleMonetateCampaigns = (experiences) => {
    const campaigns = getCampaigns(experiences);

    if (!campaigns?.length) {
      return;
    }

    window.jlData = window.jlData || {};
    window.jlData.monetateServer = window.jlData.monetateServer || {};
    const monetateCampaigns = window.jlData.monetateServer.campaigns || [];
    const concatedCampaigns = monetateCampaigns.concat(campaigns);
    const uniqueCampaigns = getUniqueCampaigns(concatedCampaigns);
    window.jlData = {
      ...window.jlData,
      monetateServer: {
        ...window.jlData.monetateServer,
        campaigns: uniqueCampaigns,
      },
    };
  };

  // To get the parameter value of the particluar experience
  // Call canShowExperience(@args1, @args2, @args3) which returns the boolean value
  // @args1 --> List of all the experiences
  // @args2 --> String value contains the particluar experience
  // @args3 --> Parameter key name of the experience
  const canShowExperience = (expriences, name, key) => {
    const selectedExperience = getExperience(expriences, name);
    const isExperiencesAvailable =
      selectedExperience && isParamTrue(selectedExperience?.parameters[key]);

    return isExperiencesAvailable || false;
  };

  // To set the event value in window.monetateQ
  // Which is the reference value for the monetate analytics data
  // Call trackMonetateEvent(@eventName)
  // @eventName --> pass the unique key value which is created as event key in Monetate Experience
  const trackMonetateEvent = (eventName) => {
    // eslint-disable-next-line
    console.log('trackMonetateEvent: ', eventName);
    window.monetateQ = window.monetateQ || [];
    window.monetateQ.push(['trackEvent', [eventName]]);
    window.monetateQ.push(['trackData']);
  };

  return {
    getMonetateExperiences,
    handleMonetateCampaigns,
    canShowExperience,
    trackMonetateEvent,
  };
};

export default useExperiences;
